import l10n from '../l10n/localization';

export default {
    client: {
        presence: {
            message: l10n.validation.required,
        },
    },
    currency: {
        presence: {
            message: l10n.validation.required,
        },
    },
    underwriter: {
        presence: {
            message: l10n.validation.required,
        },
    },
    coverType: {
        presence: {
            message: l10n.validation.required,
        },
    },
    vessel: {
        presence: {
            message: l10n.validation.required,
        },
    },
};



// WEBPACK FOOTER //
// ./src/validation/fog.js